import React from 'react'
import Button from 'material-ui/Button'
import Typography from 'material-ui/Typography';
import { withStyles } from 'material-ui/styles'
import ModalThemeProvider from './ModalThemeProvider'

const NoValidDoiModal = props => (
    <ModalThemeProvider>
        <Typography variant="display1"
            align="center"
            paragraph>
            未找到待解析的文献
        </Typography>
        <Typography variant="body2"
            align="center"
            paragraph>
            看看 DOI 号输对了吗？
        </Typography>
        <Button variant="raised"
            color="secondary"
            className={props.classes.button}
            fullWidth
            onClick={() => props.onClick()}>
            再检查一下
        </Button>
    </ModalThemeProvider>
)

export default withStyles()(NoValidDoiModal)


// WEBPACK FOOTER //
// ./src/components/modals/noValidDoi.js